export const formActions = (state = {}, action) => {
    switch (action.type) {
        case 'SET_FORM_ACTIONS':
            return {
                ...state,
                state: action.payload,
            };
        case 'REMOVE_FORM_ACTIONS':
            return {};
        default:
            return state;
    }
};
